export default "__VITE_ASSET__knInfUA4__"